export const FORM_FIELDS = {
   URL: 'linkUrl',
   TEXT: 'linkText',
   TITLE: 'linkTitle',
   OPEN_IN_NEW_TAB: 'linkOpenInNewWindow',
} as const;